import React from 'react'
import './grid_event.css';
import { convertDay } from '../../../functions/date_converter';
import { shortenText, formatProblemDisplay } from '../../../global/http_enum';
import DeleteIcon from '@mui/icons-material/Delete';
import EditIcon from '@mui/icons-material/Edit';

export default function GridEvent({ eventData, Selected, handleSelectEvent, handleOpenEvent, SetEditEvent, deleteEvent }) {

  // Format date - use created_at or date field, default to current date if not available
  const eventDate = eventData.date || eventData.created_at || new Date().toISOString();
  const formattedDate = convertDay(eventDate);

  const handleDeleteClick = (e) => {
    e.stopPropagation();
    deleteEvent(eventData.id);
  };

  const handleEditClick = (e) => {
    e.stopPropagation();
    SetEditEvent(eventData.id);
  };

  return (
    <div
      onClick={() => { handleSelectEvent(eventData) }}
      onDoubleClick={() => { handleOpenEvent(eventData) }}
      className={`${Selected === eventData.id ? 'event-selected' : ''} event-grid`}
    >
      <div className="event-header">
        <div className="event-header-content">
          <h1 className='event-name'>{eventData.name ? shortenText(eventData.name, 40) : 'Event Name'}</h1>
          <div className='event-date'>{formattedDate}</div>
        </div>
        <div className='event-actions'>
          <EditIcon className='edit-icon' onClick={handleEditClick} />
          <DeleteIcon className='delete-icon' onClick={handleDeleteClick} />
        </div>
      </div>
      <div className={`${Selected === eventData.id ? 'event-info-selected' : ''} event-info`}>
        <div className='info-field description-field'>
          <div className='field-value description-value'>
            {eventData.name ? shortenText(eventData.name, 50) : '...'}
          </div>
        </div>
        <div className='info-field problem-field'>
          <div className='field-label'>Problem</div>
          <div className='field-value problem-value'>
            {eventData.problem_identifyed_from_event ? shortenText(formatProblemDisplay(eventData.problem_identifyed_from_event), 40) : '...'}
          </div>
        </div>
        <div className='info-field'>
          <div className='field-label'>Negative Function</div>
          <div className='field-value negative-function-value'>
            {eventData.negative_function_exluded ? shortenText(eventData.negative_function_exluded, 40) : '...'}
          </div>
        </div>
      </div>
    </div>
  )
}
